import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=2a1fd9d2&scoped=true&"
import script from "./GeneralInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1fd9d2",
  null
  
)

export default component.exports